const SPOKES_COUNT = 6;

export function strokeSnowflakeSpokes(context: CanvasRenderingContext2D, radius: number): void {
  context.lineWidth = Math.max(0.6, radius * 0.14);
  context.lineCap = "round";
  for (let spoke = 0; spoke < SPOKES_COUNT; spoke++) {
    context.rotate(Math.PI / 3);
    context.beginPath();
    context.moveTo(0, 0);
    context.lineTo(0, radius);
    context.moveTo(0, radius * 0.62);
    context.lineTo(radius * 0.24, radius * 0.8);
    context.moveTo(0, radius * 0.62);
    context.lineTo(-radius * 0.24, radius * 0.8);
    context.stroke();
  }
}
